"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InversifyUtils = void 0;
/**
 * Inversify utilities
 */
var InversifyUtils;
(function (InversifyUtils) {
    function singletonFactory(factory) {
        let value = undefined;
        return (ctx) => {
            if (value === undefined) {
                value = factory(ctx);
            }
            return value;
        };
    }
    InversifyUtils.singletonFactory = singletonFactory;
})(InversifyUtils = exports.InversifyUtils || (exports.InversifyUtils = {}));
//# sourceMappingURL=inversify.js.map